var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({staticClass:"font-weight-medium",attrs:{"outlined":"","dense":"","persistent-hint":"","value":_vm.value},on:{"input":_vm.updateValue}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }